import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { BffUserService } from '@canvas/four-r-digital';
import { map, switchMap } from 'rxjs';

export const roleGuard: CanMatchFn = (route) => {
  const bff = inject(BffUserService);
  const router = inject(Router);

  const requiredRole = route.data?.['role'];
  if (!requiredRole) return true;

  return bff.isAuthenticated().pipe(
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) {
        return [router.parseUrl('')];
      }
      
      return bff.matchesClaim(requiredRole).pipe(
        map((allowed) => (allowed ? true : router.parseUrl('forbidden')))
      );
    })
  );
};
